"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HasNextStateBase = void 0;
const Entities_1 = require("../../Entities");
class HasNextStateBase extends Entities_1.RequestHandler {
    castPayloadV1(payload) {
        const castPayload = payload;
        if (!castPayload.callback) {
            throw new Entities_1.UnableToParsePayload(this.requestType, 1, JSON.stringify(payload));
        }
        return castPayload;
    }
    constructor(hostHandler) {
        super();
        this.requestType = "HAS_NEXT_STATE";
        this.action = () => {
            throw new Entities_1.ActionNotImplemented(this.requestType);
        };
        this.handleRequest = (version, payload) => {
            if (version === 1) {
                const { callback } = this.castPayloadV1(payload);
                this.action(callback);
            }
            else {
                throw new Entities_1.UnsupportedRequestVerion(this.requestType, version);
            }
        };
        hostHandler.registerRequestHandler(this);
    }
}
exports.HasNextStateBase = HasNextStateBase;
